import React, { useState, useEffect } from "react";
import axios from "axios";
import FindJobCard from "../components/FindJob/FindJobCard";
import NoImage from "../Assets/Images/no-img.jpg";

const FindJobs = ({ searchParams, setIsSearching }) => {
  const [findJobs, setFindJobs] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getFindJobs = () => {
      setLoading(true);
      if (
        (searchParams?.keywords !== undefined &&
          searchParams?.keywords !== "") ||
        (searchParams?.jobId !== undefined && searchParams?.jobId !== "") ||
        (searchParams?.location !== undefined &&
          searchParams?.location !== "") ||
        (searchParams?.category !== undefined && searchParams?.category !== "")
      ) {
        setIsSearching(true);
      }
      axios
        .post("https://hrms-api.apisod.ai/api/job-list", {
          limit: 10,
          page: page,
          job_title: searchParams.keywords || searchParams.jobId,
          location: searchParams.location,
          job_function_id: searchParams.category,
        })
        .then((res) => {
          if (page === 1) {
            setFindJobs(res.data.data); // Set new jobs
          } else {
            setFindJobs((prevJobs) => [...prevJobs, ...res.data.data]); // Append new jobs
          }
          setLoading(false);
          setIsSearching(false);
        })
        .catch((e) => {
          console.log(e);
          setLoading(false);
          setIsSearching(false);
        });
    };
    getFindJobs();
  }, [page, searchParams]);

  useEffect(() => {
    setPage(1); // Reset page to 1 when search parameters change
  }, [searchParams]);

  const loadMoreJobs = () => {
    setPage((prevPage) => prevPage + 1); // Increment the page
  };

  const extractTextFromHTML = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.innerText || tempDiv.textContent;
  };

  // Transform the findjobs data to match the jobs format
  const transformedFindJobs = findJobs.map((job) => ({
    imageUrl: NoImage, // Or a placeholder image if necessary
    jobTitle: job.job_title,
    jobId: job.job_id,
    jobTypes: [job.job_type, job.work_model, job.shift_timing], // Convert to array
    skills: job.skills_required.join(", "),
    postedDate: `Posted on ${job.job_posting_date}`,
    category: job.job_function?.name || "Not Specified", // Assuming job_function might have a name
    location: job.location,
    salary: job.salary_range,
    jobDetailsLink: `job-details/${job.job_id}`, // Assuming dynamic URL
    applyLink: "candidates-dashboard-applied-job.html",
    description: extractTextFromHTML(job.job_description),
  }));

  return (
    <div className="find-jobs-area pt-3">
      <div className="container">
        <div className="section-title text-center">
          <h2 style={{ color: "var(--titleColor)" }}>Find Your Dream Job</h2>
          {/* <div className="bar m-auto"></div>
          <p className="m-auto">144 jobs live - 20 added today.</p> */}
        </div>

        <div className="row pt-45">
          {transformedFindJobs.map((job, index) => (
            <div className="col-lg-12" key={index}>
              <FindJobCard jobData={job} />
            </div>
          ))}
          <div className="col-lg-12 text-center">
            <div className="browse-btn">
              <a
                onClick={loadMoreJobs}
                aria-disabled={loading}
                style={{ cursor: "pointer", transition: "var(--transition)" }}
              >
                Load More Job Opportunity{" "}
                <i className="ri-arrow-right-s-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FindJobs;
